import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Text from '../../Text';
import { UserSettings } from './style';
import CustomSelect from '../../CustomSelect';
import {
  SAVE_PRINT_SETTINGS,
  STATS_USER_LIST,
} from '../../../../app/redux/actions/statistics';
import { getFilterLabel, getFilterOptions } from '../../../../utils/labels';
import { EXPORT_TABS } from '.';

const TutorsTab = ({ filters, getUsers, savePrintSettings }) => {
  const [selectedFilters, setSelectedFilters] = useState({
    filters_only: true,
  });

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
    savePrintSettings({
      key,
      value: value?.value,
    });
    if (key === 'ffoo' || key === 'regions') getUsers(newFilters);
  };

  const isMandatory = (key) => {
    if (key === 'ffoo') return 'mandatory';
    return '';
  };

  return (
    <>
      <Text type="h2" mb={8}>
        Tutor
      </Text>
      <Text type="b3" mb={24}>
        Da questa sezione puoi scaricare la lista di tutor accreditati
        all’interno della piattaforma.
      </Text>
      <UserSettings>
        <div className="user-settings">
          <Text type="h3" mb={8}>
            Impostazioni
          </Text>
          <Text type="b3" mb={32}>
            Per procedere con l’export, seleziona i filtri in base alle tue
            esigenze.
          </Text>
          <div className="select-grid">
            {(Object.keys(filters) || []).map((key, i) => (
              <div key={`filter-${i}`}>
                <Text type="h3" mb={16} className={isMandatory(key)}>
                  {getFilterLabel(key)}
                </Text>
                <CustomSelect
                  size="s"
                  wrapperId={`filter-${key}`}
                  placeholder={getFilterLabel(key)}
                  options={getFilterOptions(filters, key)}
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              </div>
            ))}
          </div>
        </div>
      </UserSettings>
    </>
  );
};

TutorsTab.propTypes = {
  filters: PropTypes.object,
  getUsers: PropTypes.func,
  savePrintSettings: PropTypes.func,
};

export default connect(
  (state) => {
    const { users: printSettings } = state.statistics.printSettings;
    const { filters } = state.statistics.tutors;
    return { printSettings, filters };
  },
  (dispatch) => ({
    savePrintSettings: ({ key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        key,
        value,
        tab: EXPORT_TABS.TUTORS,
      }),
    getUsers: (filters) =>
      dispatch({ type: STATS_USER_LIST._REQUEST, filters, saveIn: 'tutors' }),
  })
)(TutorsTab);
